export default {
    greyLight: '#6676AA',
    grey: '#d9dedf',
    greyMedium: '#cecdcc',
    greyMediumer: '#616868',
    greyMediumest: '#5c6069',
    greyDark: '#3F4141',
    greyDarkish: '#2a2d33',
    greyDarker: '#1E252E',

    greyTealDark: '#789B9D',
    greyTeal: '#a3cacd',
    greyTealLight: '#bdedf1',

    blueLighter: '#B2BBEE',
    blueLight: '#808EE1',
    blue: '#576DE7',
    blueDark: '#273aa2',

    pinkLightest: '#D3BBF2',
    pinkLighter: '#D68DF0',
    pinkLight: '#EC75CB',
    pink: '#F95DB2',
    pinkDark: '#e86ebf',

    greenLighter: '#E7FFED',
    greenLight: '#ACFFC3',
    green: '#85EBA2',
    greenDark: '#59DF7F',

    tealLighter: '#94eeee',
    tealLight: '#65e0e0',
    teal: '#41c7c7',
    tealDark: '#2ba7a7',
    tealDarker: '#1d7e7e',

    purpleLight: '#B096E7',
    purple: '#7854C3',
    purpleDark: '#57457C',

    redLighter: '#f8a8a8',
    redLight: '#fc8f8f',
    red: '#FE6A6A',
    redDark: '#ec5555',
    redDarker: '#D13F3F',

    orangeDarker: '#ab5a0e',
    orangeDark: '#ce7019',
    orange: '#EF8D33',
    orangeLight: '#ffa958',
    orangeLighter: '#fdbd81',

    yellowDark: '#afa81f',
    yellow: '#fbf34c',
    skyblueDark: '#1372ad',
    skyblue: '#1ea0f2',
    oliveDark: '#3c7920',
    olive: '#599E38',
    aquaDark: '#1d847d',
    aqua: '#3ABBB3',
    indigo: '#4861EC',

    white: '#ffffff',

    primary100: '#001a72',
    primary80: '#33488E',
    primary60: '#6676AA',
    primary40: '#99A3C7',
    primary20: '#C1C6E5',

    accentYellow: '#ffe780',
    accentBlue: '#87cce8',
    accentRed: '#ffa3a1',
    accentGreen: '#b1dfd0',
    brandGreen100: '#57B495',
    brandGreen80: '#82CAB2',
    brandGreen60: '#B1DFD0',
    brandGreen40: '#DFF2EC',
    brandGreen20: '#EBFCF7',

    brandPink100: '#FF6259',
    brandPink80: '#FA7F7C',
    brandPink60: '#FFA3A1',
    brandPink40: '#FFD2D7',
    brandPink20: '#FFEDF0',

    brandYellow40: '#FFF1B2',

    brandSeaBlue80: '#5BB9E0',
    brandSeaBlue40: '#B5E1F1',
    brandSeaBlue20: '#E1F3FA'
} as const
